import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Create_Assessment_Activity/create_successfull/successfullActivity.css";

const SuccessfullActivity = () => {
  const navigate = useNavigate();
  let Header=localStorage.getItem("Header");
  const OkayClickHandle=()=>{
    navigate(Header==="Content Management (Activity)"?"/contentMangment":"/PublishedHomeworkActivity")
    if(Header==="Content Management (Activity)"){
      localStorage.setItem("Header","Content Management");
    }
  }
  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
        <img className="activityLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" my-4 successfully_message">
          You have successfully published Activity.
        </span>
          <button className="successfull_okay_btn" onClick={()=>{OkayClickHandle()}}>Okay</button>
      </div>
    </div>
  );
};

export default SuccessfullActivity;
